function getComparisonSeriesIndexes(data) {
  return data.map(({
    metadata
  }, index) => {
    if ((metadata === null || metadata === void 0 ? void 0 : metadata.comparisonIndex) != null) {
      return {
        originalIndex: index,
        comparisonIndex: metadata.comparisonIndex
      };
    }
  }).filter(Boolean);
}

export { getComparisonSeriesIndexes };
